import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function useProjects(category = null) {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchProjects() {
      try {
        setLoading(true)
        setError(null)

        let query = supabase
          .from('projects')
          .select('*')
          .order('created_at', { ascending: false })

        // Filter by category if provided
        if (category) {
          query = query.eq('category', category)
        }

        const { data, error: fetchError } = await query

        if (fetchError) {
          throw fetchError
        }

        // Transform the data to match the expected format
        const transformedProjects = data.map(project => ({
          title: project.title,
          targetSection: project.target_section,
          Category: project.category,
          shortContent: project.short_content,
          title2: project.title2,
          objective: project.objective,
          title3: project.title3,
          longContent1: project.long_content1,
          longContent2: project.long_content2,
          longContent3: project.long_content3,
          pictureSrc: project.picture_src,
          Collaborators: project.collaborators,
          id: project.id,
          createdAt: project.created_at,
          updatedAt: project.updated_at
        }))

        setProjects(transformedProjects)
      } catch (err) {
        console.error('Error fetching projects:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchProjects()
  }, [category])

  return { projects, loading, error }
}

// Hook for fetching a single project by target section
export function useProject(targetSection) {
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchProject() {
      try {
        setLoading(true)
        setError(null)
        
        console.log('Fetching project with targetSection:', targetSection)

        const { data, error: fetchError } = await supabase
          .from('projects')
          .select('*')
          .eq('target_section', targetSection)
          .limit(1)

        if (fetchError) {
          throw fetchError
        }

        console.log('Query result:', { data, error: fetchError })

        if (data && data.length > 0) {
          const projectData = data[0]; // Get the first (and should be only) result
          // Transform the data to match the expected format
          const transformedProject = {
            title: projectData.title,
            targetSection: projectData.target_section,
            Category: projectData.category,
            shortContent: projectData.short_content,
            title2: projectData.title2,
            objective: projectData.objective,
            title3: projectData.title3,
            longContent1: projectData.long_content1,
            longContent2: projectData.long_content2,
            longContent3: projectData.long_content3,
            pictureSrc: projectData.picture_src,
            Collaborators: projectData.collaborators,
            id: projectData.id,
            createdAt: projectData.created_at,
            updatedAt: projectData.updated_at
          }
          setProject(transformedProject)
        } else {
          // No project found
          setProject(null)
        }
      } catch (err) {
        console.error('Error fetching project:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    if (targetSection) {
      fetchProject()
    }
  }, [targetSection])

  return { project, loading, error }
}
